const titleIcon = "h-5 w-5 text-primary shrink-0";

const pageTitle = "text-lg sm:text-xl font-bold text-foreground tracking-tight";

const backBtn = "shrink-0";

const bodyContainer = "flex flex-col flex-1 min-h-0 px-4 md:px-6 overflow-auto md:grid md:grid-cols-[1fr_380px]";

const mainColumn = "flex flex-col flex-1 min-h-0 pr-4 md:pr-6";

const bodyInner = "flex flex-col flex-1 min-h-0";

const historyPanel = "hidden md:block md:w-[380px] md:overflow-auto";

const mobileHistoryBar = "md:hidden shrink-0 border-t border-border/60 p-3";

const historyOverlay = "md:hidden fixed inset-0 z-50 bg-black/50";

const historySheet = "flex flex-col h-full bg-background";

const historySheetHeader = "flex items-center justify-between p-4 border-b border-border shrink-0";

const icon = "h-4 w-4 mr-2";

const title = "text-lg font-bold text-foreground";

const sheetContent = "flex-1 overflow-auto p-4";

export {
  titleIcon,
  pageTitle,
  backBtn,
  bodyContainer,
  mainColumn,
  bodyInner,
  historyPanel,
  mobileHistoryBar,
  historyOverlay,
  historySheet,
  historySheetHeader,
  icon,
  title,
  sheetContent,
};
